export default "__VITE_ASSET__CkCtJ3Hr__"